import { useRetrieveListByGet } from 'src/compass/shared/hooks/reactQuery/useRetrieveListByGet';

export default function useSiteProperties() {
  return useRetrieveListByGet({
    url: 'Public/Properties/Site',
    staleTime: Infinity,
  });
}
